<template>
  <div class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable justify-content-center">
    <div class="popup-package pop-card-edit">
      <button class="btn-close" href="#" @click="hideCVV" />
      <div class="popup-content">
        <div class="popup-header" />
        <div class="popup-body">
          <div class="credit-cvv-frame">
            <div class="d-flex">
              <div class="icon-cvv-que">
                ?
              </div>
              <div>{{ $t('Bao.security_code_explain') }}</div>
            </div>
            <p>
              {{ $t('Bao.security_code_detail') }}
            </p>
            <img :src="require(`@/assets/${$store.getters.currentTheme}/images/creditcard-front.png`)" alt="">

            <!-- <p>{{ $t('Bao.security_code_american_express') }}</p>

            <img :src="require(`@/assets/${$store.getters.currentTheme}/images/creditcard-back.png`)" alt=""> -->
            <a class="btn-close-cvv" @click="hideCVV">{{ $t('Bao.close') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PerformanceModal',
  props: {
    isActive: Boolean

  },
  data() {
    return {

    }
  },
  computed: {

  },

  created() {

  },
  methods: {
    hideCVV() {
      this.$emit('closeCVV')
    }

  }
}
</script>
